



































































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import moment from "moment";
import { GetExams$ } from "@/request/shezhenjiaoxue";
import SimplePagination from "@/components/simple_pagination.vue";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import NavLeft from "../../components/left-nav.vue";
@Component({
  components: {
    MainHeader,
    NavLeft,
    SimplePagination,
  },
})
export default class SjkList extends Vue {
  // 列表
  private exams: any[] = [];
  /**
   * @description 跳转考试记录
   */
  private jumpResult() {
    this.$router.push("/main/szjx/szks-result-list");
  }
  /**
   * @description 获得考试列表
   */
  private fetchExamList() {
    GetExams$(this).then((data: any) => {
      data.forEach((exam: any) => {
        if (exam["考试状态"] === "考试中") {
          exam["startedTime"] = (moment(exam["开始时间"]) as any).from(
            moment.now(),
            true
          );
        } else {
          exam["leftTime"] = (moment(exam["开始时间"]) as any).from(
            moment.now(),
            true
          );
        }
      });
      this.exams = data;
    });
  }
  /**
   * @description 开始考试
   */
  private startExam(exam: any) {
    this.$router.push({
      path: "/main/szjx/szks-detail",
      query: {
        test_id: exam.test_id,
        exam_id: exam.exam_id,
      },
    });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    moment.locale("zh-cn");
    this.fetchExamList();
  }
}
